// App.js
import { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import MainLayout from "./layouts/MainLayout.js";
// import { BreatheLandingPage } from "./pages/OldLandingPage.js";
// import LottieAnimation from "./components/LottieAnimation.js";
import Reflect from "./pages/Reflect";
import ConnectSoonPage from "./pages/ConnectComingSoon.js";
import SaveNotePage from "./pages/SaveNote.js";
import HeartPage from "./pages/HeartPage.js";
import Storybook from "./pages/Storybook";
import HomePage from "./pages/Home";
import ConnectPage from "./pages/Connect";
import WalkRoom from "./components/connect/WalkRoom";
import { v4 as uuidv4 } from "uuid";
import AddToHomePrompt from "./components/AddToHomePrompt";
import LatestBreathsPage from "./pages/LatestBreathsPage";
import HerEchoesPage from "./pages/HerEchoesPage";

// import fallingLeaves from "./assets/animations/falling-leaves.json";

export default function App() {
  useEffect(() => {
    let userId = localStorage.getItem("breatheUserId");
    if (!userId) {
      userId = uuidv4();
      localStorage.setItem("breatheUserId", userId);
    }
  }, []);

  return (
    <Router>
      <MainLayout>
        {/* <LottieAnimation animation={fallingLeaves} /> */}

        <AddToHomePrompt />

        <Routes>
          {/* <Route path="/" element={<HomePage />} /> */}
          {/* Redirect root to /home */}
          <Route path="/" element={<Navigate to="/home" replace />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/storybook" element={<Storybook />} />

          {/* All features 👇 */}
          <Route path="/reflect" element={<Reflect />} />
          {/* Archive folded into the book — keep the path alive for old links */}
          <Route path="/archive" element={<Navigate to="/storybook" replace />} />
          <Route path="/connect-soon" element={<ConnectSoonPage />} />
          <Route path="/connect" element={<ConnectPage />} />
          <Route path="/saveanote" element={<SaveNotePage />} />
          <Route path="/walk/:roomId" element={<WalkRoom />} />

          {/* About me page 👇 */}
          <Route path="/heart" element={<HeartPage />} />
          <Route path="/her-echoes" element={<HerEchoesPage />} />
          <Route path="/latest-breaths" element={<LatestBreathsPage />} />
          {/* <Route path="/about" element={<BreatheLandingPage />} /> */}

          {/* Catch-all route for undefined paths */}
          <Route path="*" element={<Navigate to="/" replace />} />

        </Routes>
      </MainLayout>
    </Router>
  );
}
